export default __webpack_public_path__ + "static/SaolDisplay-Regular-3617f129e572ab0025ff093a9f067519.eot";